var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticStyle:{"text-align":"right"}},[_c('small',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.footer_text))])])}
var staticRenderFns = []

export { render, staticRenderFns }